var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDots = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19999 11.9981C7.19999 13.0585 6.34037 13.9181 5.27999 13.9181C4.2196 13.9181 3.35999 13.0585 3.35999 11.9981C3.35999 10.9377 4.2196 10.0781 5.27999 10.0781C6.34037 10.0781 7.19999 10.9377 7.19999 11.9981Z",
    fill: "#868381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92 11.9981C13.92 13.0585 13.0604 13.9181 12 13.9181C10.9396 13.9181 10.08 13.0585 10.08 11.9981C10.08 10.9377 10.9396 10.0781 12 10.0781C13.0604 10.0781 13.92 10.9377 13.92 11.9981Z",
    fill: "#868381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.64 11.9981C20.64 13.0585 19.7804 13.9181 18.72 13.9181C17.6596 13.9181 16.8 13.0585 16.8 11.9981C16.8 10.9377 17.6596 10.0781 18.72 10.0781C19.7804 10.0781 20.64 10.9377 20.64 11.9981Z",
    fill: "#868381"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dots.a14ade24.svg";
export { ForwardRef as ReactComponent };